import request from '@/util/request'

export function selectRealSceneData(data) {
  return request({
    url: '/iot/analysis/time/selectRealSceneData',
    method: 'post',
    data: data
  })
}

export function selectDevRealData(data){
  return request({
    url: '/iot/analysis/time/selectDevRealData',
    method: 'post',
    data: data
  })
}

export function addOrEditRealData(data){
  return request({
    url: '/iot/map/parameter/addOrEdit',
    method: 'post',
    data: data
  })
}

export function deleteRealData(siteId){
  return request({
    url: '/iot/map/parameter/delete?id='+siteId,
    method: 'post'
  })
}

//-----
export function addOrEditDevice(data){
  return request({
    url: '/iot/device/location/addOrEdit',
    method: 'post',
    data: data
  })
}

export function deleteDevice(devId){
  return request({
    url: '/iot/device/location/delete?id='+devId,
    method: 'post'
  })
}